module.exports = __webpack_public_path__ + "img/shiri_laptop.3c3604ca.png";